import React, { useState } from 'react'
import { TextInputField, Pane, Heading, Icon, toaster } from 'evergreen-ui'
import BtnDefault from '../../Components/BtnDefault'
import axios from '../../Utils/axios';
import to from 'await-to-js'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { defPassword } from '../../Redux/reducers/auth';
const Password = ({
  dispatch, history, ...props
}) => {
  const [form, setForm] = useState({
    password: '',
    confirmPassword: ''
  })

  async function createPassword() {
    const { password, confirmPassword } = form

    if (password.length < 8) {
      return toaster.danger('Informe ao menos 8 caracteres')
    }

    if (password !== confirmPassword) {
      return toaster.danger('Senhas devem ser iguais')
    }
    const [err, res] = await to(axios.post(`/accounts/password`, { password }))

    if (err) {
      return toaster.danger('Erro ao criar nova senha')
    }

    if (res.status === 200) {

      dispatch(defPassword())
      history.push('/')

    }
  }

  return (
    <div className='content'>
      <div className='login-div'>
        <form onSubmit={(e) => {
          e.preventDefault()
          createPassword()
        }}>
          <Pane flex={1} alignItems="center" display="flex">
            <Heading size={600}> <Icon icon="lock" color='gold' size={25} /> Digite a nova senha </Heading>
          </Pane>
          <Pane flex={1} alignItems="center" marginTop={10}>
            <TextInputField
              label='Senha'
              description=""
              type="password"
              name='password' placeholder='Senha'
              value={form.password}
              onChange={({ target }) => setForm({ ...form, [target.name]: target.value })} />
            <TextInputField
              name='confirmPassword'
              placeholder='Confirmar Senha' label='Confirmar senha'
              type='password'
              value={form.confirmPassword}
              onChange={({ target }) => setForm({
                ...form,
                [target.name]: target.value
              })}
              description="" />

            <BtnDefault
              icon='log-in'
              type='submit'
              height={40}
              appearance="primary"
              onClick={(e) => {
                e.preventDefault()
                createPassword()
              }}> Cadastrar </BtnDefault>

          </Pane>
        </form>
      </div >

    </div>
  )
}

const mapStateToProps = (state) => state
export default withRouter(connect(mapStateToProps)(Password))